export default __webpack_public_path__ + "static/media/svg-5.75a7dbc2.svg";